import type { FC } from "react";

interface DisadvantageIconProps {
  className?: string;
}

export const DisadvantageIcon: FC<DisadvantageIconProps> = ({ className }) => (
  <svg viewBox="0 0 48 48" className={className}>
    <g>
      <polygon fill="#fff" points="35 8 36 39 12 39 14 8" />
      <path
        fill="#b00000"
        d="M27.38,17.75a9.362,9.362,0,0,1,1.44,5.68v1.12a9.4423,9.4423,0,0,1-1.44,5.71A5.21983,5.21983,0,0,1,23,32H21V16h2A5.19361,5.19361,0,0,1,27.38,17.75Z"
      />
      <path
        fill="#b00000"
        d="M44.39,12.1,23.89.39,3.5,12.29,3.61,35.9l20.5,11.71L44.5,35.71ZM35.21,24.55a13.50293,13.50293,0,0,1-1.5,6.41,11.09308,11.09308,0,0,1-4.25,4.42A12.00926,12.00926,0,0,1,23.34,37H15V11h8.16a12.35962,12.35962,0,0,1,6.2,1.56,10.97521,10.97521,0,0,1,4.29,4.41,13.31084,13.31084,0,0,1,1.56,6.39Z"
      />
    </g>
  </svg>
);
